import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Alert as Allert, Modal } from "antd";
import React, { Component } from "react";
import { Context } from "../Context";
import { CustomPrimaryButton } from "./index";

const ConformationModal = Form.create()(
  class extends Component {
    static contextType = Context;
    constructor(props) {
      super(props);
      this.state = {
        message:this.props.message
      };
    }
    
    render() {
      return (
        <Modal open={this.props.visible} onCancel={this.props.onCancel} footer={null} 
        closable={true}
        bodyStyle={{ padding: 30 }}
        centered
        mask={true}
        width={500}
        height={400}
        >
         <Allert
            style={{ marginBottom: 20 }}
            message="Note"
            description={this.props.message}
            type="info"
            showIcon
          />
            
            <div className="footer-button-group">
                <CustomPrimaryButton disabled={false} buttonClick={this.props.submitConformation} className="create-journey" label="Save" />
            </div>
        </Modal>
      );
    }
  }
);
export default ConformationModal;
